const pressableSize = {
    sm: 36,
    md: 44,
    lg: 52,
};
export default pressableSize;
